import GlobalSearchGrid from "../../components/grids/GlobalSearchGrid";
import { GlobalSearchItem } from "../../types/globalSearch.types";

export default function GlobalSearch() {

    /**
     * Handles the click event on a row in the global search results.
     * 
     * @param record - The record representing the clicked item.
     */
    const onRowClick = (record: GlobalSearchItem) => {
        if (record.type === "Enquiry") {
            window.open(`/enquiries/?id=${record.id}`, "_blank");
        }

        if (record.type === "Quote") {
            window.open(`/quotes/?id=${record.id}`, "_blank");
        }

        if (record.type === "Job") {
            window.open(`/jobs/?id=${record.id}`, "_blank");
        }

        if (record.type === "Diary") {
            window.open(`/diary/?jobId=${record.id}&appointmentId=${record.appointmentId}`, "_blank");
        }
    }

    return (

        <div>

            <GlobalSearchGrid
                onRowClick={onRowClick}
            />

        </div>
    )
}